// Generated by ChartDataGenerator. Do not edit manually.
package com.veldekar.charts

import kotlin.Int
import kotlin.collections.List

public data class SessionYearData(
    public val year: Int,
    public val winter: Int,
    public val spring: Int,
    public val summer: Int,
    public val fall: Int,
) {
    public val total: Int
        get() = winter + spring + summer + fall
}

public object ChartResources {
    public fun sessionsByYear(): List<SessionYearData> {
        return listOf(
            SessionYearData(2_023, 7, 9, 10, 3),
            SessionYearData(2_024, 7, 8, 1, 3),
            SessionYearData(2_025, 11, 10, 0, 6),
            SessionYearData(2_026, 7, 9, 4, 1),
        )
    }
}
